<template>
  <import-data-view type="posm" title="POSM"></import-data-view>
</template>

<script>
    import ImportDataView from '@/components/import/ImportDataView';

    export default {
        components: {
            ImportDataView,
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/ui/ImportPosm.vue